<template>
  <v-app>

      <v-app-bar
          color="primary"
          dark
          dense
          app
      >
        <v-app-bar-nav-icon v-if="loggedIn"
                            @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

        <v-toolbar-title>FieldAgent Tagging - {{ $route.path }} </v-toolbar-title>


        <v-spacer></v-spacer>
        <v-btn v-if="loggedIn" color="primary" depressed light tile @click="doLogout"> Logout</v-btn>

      </v-app-bar>

      <v-navigation-drawer
          v-if="loggedIn"
          v-model="drawer"
          absolute
          app
          temporary
      >

        <v-list
            dense
            nav
        >
          <v-list-item-group
              v-model="group"
              active-class="primary--text text--accent-4"
          >
            <v-list-item v-if="user.roles.includes('Tagger')" >
              <router-link to="/tagging">
              <v-list-item-title>Photo Tagging</v-list-item-title>
                </router-link>
            </v-list-item>


            <v-list-item v-if="user.roles.includes('Quality Control')" >
              <router-link to="/quality-control">
              <v-list-item-title>Quality Control</v-list-item-title>
              </router-link>
            </v-list-item>

            <v-list-item v-if="user.roles.includes('Sys Admin')" >
              <router-link to="/manage-tags">
              <v-list-item-title >Manage Tags</v-list-item-title>
              </router-link>
            </v-list-item>

            <v-list-item v-if="user.roles.includes('Auth Admin')" >
              <router-link to="/manage-users">
              <v-list-item-title>Manage Users</v-list-item-title>
              </router-link>
            </v-list-item>
            <v-list-item v-if="user.roles.includes('Auth Admin')" >
              <router-link to="/query-photos">
              <v-list-item-title>Query Photos</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

    <v-snackbar
          v-model="message.alert"
          :timeout="3000"
          :top='true'
          right>
            <span class='d-inline-block align-top' style='width: calc(100% - 34px)'
              v-html='message.text'></span>
    </v-snackbar>
    <v-main>
      <router-view></router-view>
    </v-main>

  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import {mapActions, mapMutations, mapState} from 'vuex'

export default {
  name: 'App',
  components: {},
  data() {
    return {
      drawer: false,
      group: null,
      isInactive: false,
      userActivityThrottlerTimeout: null,
      userActivityTimeout: null,
    }
  },
  computed: {
    ...mapState({
      message: state => state.messages.message,
      loggedIn: state => state.auth.loggedIn,
      user: state => state.auth.profile.user
    }),
  },
  beforeMount() {
    let self = this
    window.addEventListener('beforeunload', function (event) {
      self.clearAssignedPhotos()
      let confirmationMessage = "";
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    })
    this.activateActivityTracker();
  },
  mounted() {
    if (this.loggedIn) {
      this.getCategoriesList();
      this.getTagsList();
      // this.getPhotosList();
      // this.getUsersList();
      // this.getJobList();
      // this.getProjectList();
      // this.getRolesList();
      // this.getResponseIds();
      // this.getTaggerResponseIds();
    }
  },
  methods: {
    ...mapActions([
      'getCategoriesList',
      'getTagsList',
      'getPhotosList',
      'getUsersList',
      'getJobList',
      'getProjectList',
      'getRolesList',
      'getQCList',
      'getSAList',
      'clearAssignedPhotos',
      'getResponseIds',
      'getTaggerResponseIds',
    ]),
    ...mapMutations(['logout']),
    doLogout() {
      this.clearAssignedPhotos()
      this.logout()
      this.$router.push('/login')
    },
    activateActivityTracker() {
      window.addEventListener("mousemove", this.userActivityThrottler);
    },
    resetUserActivityTimeout() {
      clearTimeout(this.userActivityTimeout);
      // Default to 1h if VUE_APP_INACTIVE_TIME is unset at build time. Without this,
      // setTimeout(fn, undefined) coerces the delay to 0ms and logs the user out
      // immediately on first activity.
      const inactiveTime = parseInt(process.env.VUE_APP_INACTIVE_TIME, 10) || 3600000;
      this.userActivityTimeout = setTimeout(() => {
        this.inactiveUserAction();
      }, inactiveTime);
    },
    userActivityThrottler() {
      if (!this.userActivityThrottlerTimeout) {
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.resetUserActivityTimeout();

          clearTimeout(this.userActivityThrottlerTimeout);
          this.userActivityThrottlerTimeout = null;
        }, 1000);
      }
    },
    inactiveUserAction() {
      this.clearAssignedPhotos()
      this.doLogout()
    }

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}


</style>
